import React from 'react'
import {Box, Text} from '../../../vanilla'
import {LiveTextBannerProps} from '../../../types/cms/delivery-banner'
import * as styles from './styles.css'

export const LiveTextBanner: React.FC<LiveTextBannerProps> = ({
  title,
  subtitle,
  titleTextColour,
}) => {
  return (
    <Box className={styles.textWrapper}>
      <Text
        className={styles.title}
        style={{
          color: titleTextColour?.color || undefined,
        }}
      >
        {title}
      </Text>
      {subtitle && (
        <Box className={styles.supportingText}>
          <Text className={styles.subtitle}>{subtitle}</Text>
        </Box>
      )}
    </Box>
  )
}
